module.exports = __webpack_public_path__ + "img/melon.68838af5.svg";